import * as Reakit from 'reakit/Tooltip'

import { COMPONENT_ANIMATION_DURATION } from '../constants'

/**
 * Hook which provides state to tooltips
 */
export function useTooltipState(settings?: Reakit.TooltipInitialState) {
  return Reakit.useTooltipState({
    ...settings,
    animated: COMPONENT_ANIMATION_DURATION,
  })
}
